import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Analytics from './shared-components/Analytics/Analytics';
import Navbar from './shared-components/Navbar/Navbar';
import Footer from './shared-components/Footer/Footer';
import ScrollToTop from './shared-components/ScrollToTop/ScrollToTop';
import Homepage from './pages/Homepage/Homepage';
import WhoWeAre from './pages/WhoWeAre/WhoWeAre';
import Contact from './pages/Contact/Contact';
import EmployeeEngagement from './pages/StrategicHR/EmployeeEngagement/EmployeeEngagement';
import PerformanceManagement from './pages/StrategicHR/PerformanceManagement/PerformanceManagement';
import HRSystems from './pages/StrategicHR/HRSystems/HRSystems';
import BenefitsStrategy from './pages/StrategicHR/BenefitsStrategy/BenefitsStrategy';
import PoliciesProcedures from './pages/StrategicHR/PoliciesProcedures/PoliciesProcedures';
import OnboardingOffboarding from './pages/StrategicHR/OnboardingOffboarding/OnboardingOffboarding';
import TransitionalHR from './pages/TransitionalHR/TransitionalHR';
import Pricing from './pages/Pricing/Pricing';
import Terms from './pages/Terms/Terms';
import Privacy from './pages/Privacy/Privacy';
import ScheduleAppointment from './pages/ScheduleAppointment/ScheduleAppointment';
import NotFound from './pages/NotFound/NotFound';
import { ChatBot } from './components/ChatBot/ChatBot';
import CookieConsent from './components/CookieConsent/CookieConsent';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Analytics />
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/who-we-are" element={<WhoWeAre />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/transitional-hr" element={<TransitionalHR />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/strategic-hr/employee-engagement" element={<EmployeeEngagement />} />
              <Route path="/strategic-hr/performance-management" element={<PerformanceManagement />} />
              <Route path="/strategic-hr/hr-systems" element={<HRSystems />} />
              <Route path="/strategic-hr/benefits-strategy" element={<BenefitsStrategy />} />
              <Route path="/strategic-hr/policies-procedures" element={<PoliciesProcedures />} />
              <Route path="/strategic-hr/onboarding-offboarding" element={<OnboardingOffboarding />} />
              <Route path="/schedule-appointment" element={<ScheduleAppointment />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <ChatBot
            apiEndpoint="/api/chat"
            leadEmail="contact@erhrglobal.com"
          />
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
